<script>
    import Empty from './layout/Empty.svelte';
    import { t } from "../i18n";
</script>



<Empty title={$t('page.notfound')}>

    <div style="margin: 100px 0 128px 0; text-align: center;">
        <h1>{$t('notfound.title')}</h1>
        <p>{$t('notfound.body')}</p>
    </div>

</Empty>

